import { render, staticRenderFns } from "./FranqueadoPendente.vue?vue&type=template&id=c17f4ef2&scoped=true"
import script from "./FranqueadoPendente.vue?vue&type=script&lang=js"
export * from "./FranqueadoPendente.vue?vue&type=script&lang=js"
import style0 from "./FranqueadoPendente.vue?vue&type=style&index=0&id=c17f4ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17f4ef2",
  null
  
)

export default component.exports